module.exports = ".mobile-apps img {\n\n    max-width: 160px;\n}"